<template>
    <div class="horizontal">
        <div id="scichart-root-api-usage" style="width: 100%; height: 220px;"></div>
    </div>
</template>

<script>
import moment from 'moment'

import { SciChartSurface } from "scichart/Charting/Visuals/SciChartSurface";
import { NumericAxis } from "scichart/Charting/Visuals/Axis/NumericAxis";
import { EAxisAlignment } from "scichart/types/AxisAlignment";
import { FastLineRenderableSeries } from "scichart/Charting/Visuals/RenderableSeries/FastLineRenderableSeries";
import { XyDataSeries } from "scichart/Charting/Model/XyDataSeries";
import { RolloverModifier } from "scichart/Charting/ChartModifiers/RolloverModifier";
import { NumberRange } from 'scichart/Core/NumberRange';
import { chartThemeMixin } from "@/utils/chartTheme";

const COUNT_COLOR = "#0095B2";
const ERROR_COLOR = "#E0544B";

// Liczba wywolan API w czasie (kubelki godzinowe albo dzienne) - widok ApiUsage.
export default {
    mixins: [chartThemeMixin],
    props: {
        // [{ periodStart, count, errorCount }] z GET ApiUsage/timeline
        points: {
            type: Array,
            required: true
        },
        hourly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            sciChartSurface: null,
            wasmContext: null,
            countSeries: null,
            errorSeries: null
        }
    },
    watch: {
        points() {
            this.setData();
        }
    },
    methods: {
        async initSciChart() {
            const { sciChartSurface, wasmContext } = await SciChartSurface.create('scichart-root-api-usage');

            this.sciChartSurface = sciChartSurface;
            this.wasmContext = wasmContext;

            await sciChartSurface.applyTheme(this.chartTheme());

            const xAxis = new NumericAxis(wasmContext, { axisAlignment: EAxisAlignment.Bottom });
            const yAxis = new NumericAxis(wasmContext, { axisAlignment: EAxisAlignment.Left });

            xAxis.labelProvider.formatLabel = (value) => moment(value).format(this.hourly ? "DD-MM HH:mm" : "DD-MM-YYYY");
            yAxis.labelProvider.formatLabel = (value) => Math.round(value).toString();
            yAxis.growBy = new NumberRange(0, 0.1);

            sciChartSurface.xAxes.add(xAxis);
            sciChartSurface.yAxes.add(yAxis);

            this.countSeries = new FastLineRenderableSeries(wasmContext, { stroke: COUNT_COLOR, strokeThickness: 2 });
            this.errorSeries = new FastLineRenderableSeries(wasmContext, { stroke: ERROR_COLOR, strokeThickness: 2 });
            this.countSeries.rolloverModifierProps.tooltipTemplate = this.tooltipTemplateMethod;
            this.errorSeries.rolloverModifierProps.tooltipTemplate = this.tooltipTemplateMethod;

            sciChartSurface.renderableSeries.add(this.countSeries);
            sciChartSurface.renderableSeries.add(this.errorSeries);

            const rolloverModifier = new RolloverModifier();
            rolloverModifier.showRolloverLine = false;
            sciChartSurface.chartModifiers.add(rolloverModifier);

            this.setData();
        },
        setData() {
            if (!this.wasmContext) {
                return;
            }

            const x = this.points.map(p => new Date(p.periodStart).getTime());

            this.countSeries.dataSeries = new XyDataSeries(this.wasmContext, {
                xValues: x,
                yValues: this.points.map(p => p.count),
                dataSeriesName: this.$t('ApiUsageCalls')
            });
            this.errorSeries.dataSeries = new XyDataSeries(this.wasmContext, {
                xValues: x,
                yValues: this.points.map(p => p.errorCount),
                dataSeriesName: this.$t('ApiUsageErrors')
            });

            this.sciChartSurface.zoomExtents();
        },
        tooltipTemplateMethod(id, seriesInfo, rolloverTooltip) {
            const colors = this.tooltipColors();
            const width = 172;
            const height = 42;
            rolloverTooltip.updateSize(width, height);

            const date = moment(Math.floor(seriesInfo.xValue)).format(this.hourly ? "DD-MM-YYYY HH:mm" : "DD-MM-YYYY");

            return `<svg width="${width}" height="${height}">
                <rect x="1" y="1" height="40" width="170" rx="5" style="stroke-width:1; stroke:${colors.border}" fill="${colors.background}"/>
                <text font-size="13" font-family="Verdana" fill="${colors.text}">
                    <tspan x="11" dy="1.2em">${date}</tspan>
                    <tspan x="11" dy="1.2em">${seriesInfo.seriesName}: ${Math.round(seriesInfo.yValue)}</tspan>
                </text>
            </svg>`;
        }
    },
    mounted() {
        this.initSciChart();
    },
    beforeDestroy() {
        if (this.sciChartSurface) {
            this.sciChartSurface.delete();
        }
        this.sciChartSurface = null;
        this.wasmContext = null;
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Charts/SciChartApiUsage.vue